/**
 * The workspace the user currently has open, for code that has no React context
 * — specifically geminiClient, a singleton the four AI services share.
 *
 * WorkspaceContext publishes it from ONE effect rather than from each of its four
 * setWorkspace call sites, so this cannot drift from what the sidebar shows.
 *
 * It is a hint about attribution, not an authority: the value is sent to the
 * proxy and the DATABASE decides whether to keep it, by checking membership.
 *
 * @module services/activeWorkspace
 */

let activeWorkspaceId: string | null = null;

export const setActiveWorkspaceId = (id: string | null): void => {
  activeWorkspaceId = id;
};

export const getActiveWorkspaceId = (): string | null => activeWorkspaceId;
